import { Component, OnInit, OnDestroy } from '@angular/core';
import { CaiConfigService } from '../../services/cai-config.service';
import { PROJECTS_PATH } from '../../routes/cai-routes.consts';
import { BrandingSettingsService } from '../../../settings/branding-settings/proxy/branding-settings.service';
import { BrandingSettingsDto } from '../../../settings/branding-settings/proxy/branding-settings.model';
import { BrandingSettingsHelperService } from '../../services/branding-settings-helper.service';

@Component({
  selector: 'cai-logo',
  template: `
    <a class="navbar-brand cai-brand-logo" [routerLink]="routerLink" alt="logo">
      @if (logoUrl) {
        <img [src]="logoUrl" alt="Logo" class="brand-logo" />
      }
    </a>
  `,
  styles: [
    `
      .cai-brand-logo {
        background: none !important;
        background-image: none !important;
        width: auto !important;
        height: auto !important;
      }
      .brand-logo {
        max-height: 40px;
        max-width: 220px;
        object-fit: contain;
        vertical-align: middle;
      }
    `,
  ],
  standalone: false,
})
export class LogoComponent implements OnInit, OnDestroy {
  routerLink: string[];
  logoUrl: string | null = null;

  constructor(
    private caiConfigService: CaiConfigService,
    private brandingSettingsService: BrandingSettingsService,
    private brandingSettingsHelper: BrandingSettingsHelperService,
  ) {
    this.routerLink = this.caiConfigService.currentTenant?.id ? [PROJECTS_PATH] : ['/'];
  }

  ngOnInit(): void {
    this.loadLogo();

    // Listen for branding updates
    window.addEventListener('branding-updated', this.handleBrandingUpdate.bind(this));
  }

  ngOnDestroy(): void {
    window.removeEventListener('branding-updated', this.handleBrandingUpdate.bind(this));
  }

  private loadLogo(): void {
    this.brandingSettingsService.get().subscribe({
      next: (settings: BrandingSettingsDto) => {
        if (settings.logoBase64 && settings.logoContentType) {
          this.logoUrl = this.brandingSettingsHelper.createDataUrl(
            settings.logoBase64,
            settings.logoContentType,
          );
          this.updateCssVariables(this.logoUrl);
        }
      },
      error: (err) => {
        console.error('Error loading logo:', err);
      },
    });
  }

  private handleBrandingUpdate(event: Event): void {
    const customEvent = event as CustomEvent<BrandingSettingsDto>;
    if (customEvent.detail?.logoBase64 && customEvent.detail?.logoContentType) {
      this.logoUrl = this.brandingSettingsHelper.createDataUrl(
        customEvent.detail.logoBase64,
        customEvent.detail.logoContentType,
      );
      this.updateCssVariables(this.logoUrl);
    }
  }

  private updateCssVariables(dataUrl: string): void {
    // Update CSS variables used by Lepton theme
    document.documentElement.style.setProperty('--logo', `url(${dataUrl})`);
    document.documentElement.style.setProperty('--logo-reverse', `url(${dataUrl})`);
  }
}
